// src/theme/tokens.ts

export const COLORS = {
  primary: '#007F7C',
  background: '#FFFAFA',
  borderPrimary: '#000000',
  disabled: '#D9D5D2',
  textPrimary: '#000000',
  textSecondary: '#FFFFFF',
  error: '#FF0000',
  // primary: '#007F7C',
  // background: '#000000',
  // borderPrimary: '#ffffff',
  // disabled: '#D9D5D2',
  // textPrimary: '#ffffff',
  // textSecondary: '#000000',
  // error: '#FF0000',
} as const

export const SHADOWS = {
  boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.20)',
} as const

export type ColorKeys = keyof typeof COLORS
export type ShadowKeys = keyof typeof SHADOWS
